<template>
    <div class="bc-container flex row no-overflow vertical-center space-evenly">
        <div class="mg-spacing">
            <img class="md-container" :src="require('../../assets/Desktop/About_Us/bc_img.png')" alt="Business Customer">
            <img class="mobile-img" :src="require('../../assets/Mobile/Mobile_About_Us/BC_IMG.png')" alt="Private Customer">
        </div>
        <div style="text-align:left;">
            <h1 class="bc-title">Business Customer</h1>
            <p class="bc-text"><strong>Money savings</strong> -  Your events staff doesn’t have to be huge or hiring a 3rd party company doesn’t have to happen because the app handles all the legwork and phone calls for your company meetings, team building trips, and anything else.</p>
            <p class="bc-text"><strong>Efficiency</strong> - Using the app will allow your staff the time to concentrate on other productive activities and do a better job at them</p>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
            }
        }
    }
</script>

<style scoped>
    @media (max-width: 880px) {
        .bc-container {
            height: 1000px !important;
            flex-direction: column !important;
        }

        .bc-text {
            width: 80vw !important;
        }

        .mobile-img {
            height: auto !important;
            width: 90vw !important;
            display: block !important;
            margin: auto !important;
        }

        .mg-spacing {
            margin: 0 !important;
        }
    }

    .mobile-img {
        display: none;
    }

    .bc-container {
        height: 656px;
        background-color: #EEEEEE;
    }

    .bc-title {
        color: #244F76;
        font-family: Trirong;
        font-size: 32px;
        font-weight: 800;
        color: #244F76;
    }

    .bc-text {
        width: 512px;
        color: #333333;
        font-family: Trirong;
        font-size: 16px;
        letter-spacing: 1px;
    }

    .mg-spacing {
        margin: 0 0 0 -150px;
    }
</style>



// WEBPACK FOOTER //
// src/components/about/Business_Customer.vue